function initProductPage(container = document) {
  /* =========================
     Back navigation
     ========================= */
  const backButton = container.querySelector('[data-pp-back]');

  if (backButton && backButton.dataset.ppBackBound !== 'true') {
    backButton.dataset.ppBackBound = 'true';

    backButton.addEventListener('click', (event) => {
      const homeUrl = backButton.dataset.homeUrl || '/';
      let referrerIsSameStore = false;

      try {
        if (document.referrer) {
          const referrerUrl = new URL(document.referrer);
          referrerIsSameStore = referrerUrl.origin === window.location.origin;
        }
      } catch (error) {
        referrerIsSameStore = false;
      }

      /*
       * Return to the customer's previous in-store page (search, collection,
       * homepage, etc.). Direct visits and external referrals fall back home.
       */
      if (referrerIsSameStore && window.history.length > 1) {
        event.preventDefault();
        window.history.back();
      } else {
        event.preventDefault();
        window.location.assign(homeUrl);
      }
    });
  }

  const cleanupPanels = () => {
    container.querySelectorAll('.pp-accordion__panel li > p').forEach((p) => {
      const li = p.parentNode;
      while (p.firstChild) li.insertBefore(p.firstChild, p);
      p.remove();
    });

    container.querySelectorAll('.pp-accordion__panel td > p, .pp-accordion__panel th > p').forEach((p) => {
      const cell = p.parentNode;
      while (p.firstChild) cell.insertBefore(p.firstChild, p);
      p.remove();
    });

    container.querySelectorAll('.pp-accordion__panel p').forEach((p) => {
      const text = p.textContent.replace(/\u00A0/g, '').trim();
      if (!text && p.children.length === 0) {
        p.remove();
      }
    });
  };

  function resetProductPageButtons(scope = document) {
    scope.querySelectorAll('[data-pp-buy-now]').forEach((button) => {
      const stockDisabled = button.dataset.stockDisabled === 'true';
      const availabilityDisabled =
        button.dataset.availabilityDisabled === 'true';

      button.classList.remove('is-loading', 'is-error');

      if (availabilityDisabled) {
        button.disabled = true;
        button.textContent = 'Sold out';
        return;
      }

      if (stockDisabled) {
        button.disabled = true;
        button.textContent =
          button.dataset.stockLabel || 'Maximum in cart';
        return;
      }

      button.disabled = false;
      button.textContent = 'Buy it now';
    });

    scope.querySelectorAll('.pp-atc').forEach((button) => {
      const stockDisabled = button.dataset.stockDisabled === 'true';
      const availabilityDisabled =
        button.dataset.availabilityDisabled === 'true';

      button.classList.remove('is-added', 'is-error');

      if (availabilityDisabled) {
        button.disabled = true;
        button.textContent = 'Sold out';
        return;
      }

      if (stockDisabled) {
        button.disabled = true;
        button.textContent =
          button.dataset.stockLabel || 'Maximum in cart';
        return;
      }

      button.disabled = false;
      button.textContent = 'Add to cart';
    });
  }

  window.addEventListener('pageshow', () => {
    resetProductPageButtons(document);
  });

  /* =========================
     Carousel
     ========================= */
  const galleryRoot = container.querySelector('[data-pp-gallery]');
  if (galleryRoot) {
    const slides = Array.from(galleryRoot.querySelectorAll('[data-pp-slide]'));
    const prev = galleryRoot.querySelector('[data-pp-prev]');
    const next = galleryRoot.querySelector('[data-pp-next]');
    const thumbs = Array.from(galleryRoot.querySelectorAll('[data-pp-dot]'));

    let index = 0;

    const show = (i) => {
      if (!slides.length) return;

      index = (i + slides.length) % slides.length;

      slides.forEach((slide, idx) => {
        const active = idx === index;
        slide.hidden = !active;
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });

      thumbs.forEach((thumb, idx) => {
        const active = idx === index;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-current', active ? 'true' : 'false');
      });
    };

    prev?.addEventListener('click', () => show(index - 1));
    next?.addEventListener('click', () => show(index + 1));

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        show(parseInt(thumb.dataset.index, 10) || 0);
      });
    });

    show(0);
  }

  /* =========================
   Quantity and stock controls
   ========================= */
  const qtyWrap = container.querySelector('.pp-qty');
  const minus = container.querySelector('[data-pp-qty-minus]');
  const plus = container.querySelector('[data-pp-qty-plus]');
  const input = container.querySelector('[data-pp-qty-input]');
  const stockMessage = container.querySelector('[data-pp-stock-message]');

  const rawMaxQty = qtyWrap?.getAttribute('data-max-qty');

  let maxQty =
    rawMaxQty !== null &&
    rawMaxQty !== '' &&
    Number.isFinite(Number(rawMaxQty))
      ? Math.max(0, parseInt(rawMaxQty, 10))
      : null;

  const clampQuantity = (value) => {
    let next = parseInt(value, 10);

    if (!Number.isFinite(next) || next < 1) {
      next = 1;
    }

    if (maxQty !== null && maxQty > 0) {
      next = Math.min(next, maxQty);
    }

    return next;
  };

  const syncQuantityControls = () => {
    if (!input) return;

    let quantity = clampQuantity(input.value);

    if (maxQty === 0) {
      quantity = 1;
      input.disabled = true;
    }

    input.value = String(quantity);

    if (maxQty !== null) {
      input.max = String(Math.max(1, maxQty));
    } else {
      input.removeAttribute('max');
    }

    if (minus) {
      minus.disabled = input.disabled || quantity <= 1;
    }

    const atMaximum =
      maxQty !== null &&
      (maxQty === 0 || quantity >= maxQty);

    if (plus) {
      plus.disabled = input.disabled || atMaximum;
    }

    if (stockMessage) {
      stockMessage.hidden = !atMaximum;

      stockMessage.textContent =
        maxQty === 0
          ? 'All available stock is already in your cart.'
          : 'Maximum available quantity reached.';
    }

    qtyWrap?.classList.toggle('is-at-limit', atMaximum);
  };

  minus?.addEventListener('click', () => {
    if (!input || minus.disabled) return;

    input.value = String(
      clampQuantity((parseInt(input.value, 10) || 1) - 1)
    );

    syncQuantityControls();
  });

  plus?.addEventListener('click', () => {
    if (!input || plus.disabled) return;

    input.value = String(
      clampQuantity((parseInt(input.value, 10) || 1) + 1)
    );

    syncQuantityControls();
  });

  input?.addEventListener('input', () => {
    input.value = String(clampQuantity(input.value));
    syncQuantityControls();
  });

  input?.addEventListener('change', () => {
    input.value = String(clampQuantity(input.value));
    syncQuantityControls();
  });

  syncQuantityControls();

  /* =========================
    AJAX add to cart + drawer event
    ========================= */
  const form = container.querySelector('#pp-product-form');
  const atcButton = form?.querySelector('[type="submit"][name="add"]');
  const buyNowButton = form?.querySelector('[data-pp-buy-now]');

  const consumeAvailableStock = (quantity) => {
    if (maxQty === null) return;

    maxQty = Math.max(0, maxQty - quantity);

    if (qtyWrap) {
      qtyWrap.dataset.maxQty = String(maxQty);
    }

    if (input) {
      input.value = '1';
      input.disabled = maxQty <= 0;
    }

    const stockDisabled = maxQty <= 0;

    [atcButton, buyNowButton].forEach((button) => {
      if (!button) return;

      button.dataset.stockDisabled = stockDisabled
        ? 'true'
        : 'false';
    });

    syncQuantityControls();
  };

  if (form && !form.dataset.ppBound) {
    form.dataset.ppBound = 'true';

    form.addEventListener('submit', async (event) => {
      event.preventDefault();

      if (!atcButton || atcButton.disabled) return;

      const formData = new FormData(form);
      const quantity = parseInt(formData.get('quantity'), 10) || 1;
      const originalText = atcButton.textContent;

      atcButton.disabled = true;
      atcButton.classList.remove('is-added', 'is-error');
      atcButton.textContent = 'Adding...';

      try {
        const addRes = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            Accept: 'application/json'
          },
          body: formData
        });

        if (!addRes.ok) {
          let message = 'Unable to add this item to cart.';
          try {
            const errorData = await addRes.json();
            if (errorData?.description) message = errorData.description;
          } catch (e) {
            // ignore JSON parse failure
          }
          throw new Error(message);
        }

        const addedItem = await addRes.json();
        consumeAvailableStock(quantity);

        atcButton.textContent = 'Added';
        atcButton.classList.add('is-added');

        animateCartFeedback(atcButton, quantity);

        window.dispatchEvent(
          new CustomEvent('cart:added', {
            detail: { item: addedItem, quantity }
          })
        );

        window.dispatchEvent(
          new CustomEvent('cart:refresh', {
            detail: {
              open: true,
              source: 'product-page',
              item: addedItem,
              quantity
            }
          })
        );
      } catch (error) {
        console.error(error);
        atcButton.textContent = 'Unavailable';
        atcButton.classList.add('is-error');

        window.dispatchEvent(
          new CustomEvent('cart:error', {
            detail: { message: error.message }
          })
        );
      } finally {
          window.setTimeout(() => {
            const permanentlyDisabled =
              atcButton.dataset.stockDisabled === 'true' ||
              atcButton.dataset.availabilityDisabled === 'true';

            atcButton.disabled = permanentlyDisabled;

            if (atcButton.dataset.availabilityDisabled === 'true') {
              atcButton.textContent = 'Sold out';
            } else if (atcButton.dataset.stockDisabled === 'true') {
              atcButton.textContent =
                atcButton.dataset.stockLabel || 'Maximum in cart';
            } else {
              atcButton.textContent = originalText;
            }

            atcButton.classList.remove('is-added', 'is-error');
          }, 1400);
        }
    });

    if (buyNowButton) {
      buyNowButton.addEventListener('click', async () => {
        if (buyNowButton.disabled) return;

        const formData = new FormData(form);
        const quantity = parseInt(formData.get('quantity'), 10) || 1;
        const originalText = buyNowButton.textContent;

        buyNowButton.disabled = true;
        buyNowButton.classList.remove('is-error');
        buyNowButton.classList.add('is-loading');
        buyNowButton.textContent = 'Adding...';

        try {
          const addRes = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              Accept: 'application/json'
            },
            body: formData
          });

          if (!addRes.ok) {
            let message = 'Unable to add this item to cart.';
            try {
              const errorData = await addRes.json();
              if (errorData?.description) message = errorData.description;
            } catch (e) {
              // ignore JSON parse failure
            }
            throw new Error(message);
          }

          const addedItem = await addRes.json();

          window.dispatchEvent(
            new CustomEvent('cart:added', {
              detail: { item: addedItem, quantity }
            })
          );

          window.dispatchEvent(
            new CustomEvent('cart:refresh', {
              detail: {
                open: false,
                source: 'product-page-buy-now',
                item: addedItem,
                quantity
              }
            })
          );

          window.location.href = '/cart';
        } catch (error) {
          console.error(error);
          buyNowButton.textContent = 'Unavailable';
          buyNowButton.classList.add('is-error');

          window.dispatchEvent(
            new CustomEvent('cart:error', {
              detail: { message: error.message }
            })
          );

          window.setTimeout(() => {
            buyNowButton.disabled = false;
            buyNowButton.classList.remove('is-loading', 'is-error');
            buyNowButton.textContent = originalText;
          }, 1400);
        }
      });
    }
  }

  initProductShippingEstimator(container);

  /* =========================
     Accordion: auto-split description
     ========================= */
  const accordionRoot = container.querySelector('[data-pp-accordion]');
  if (!accordionRoot) return;

  const itemsWrap = accordionRoot.querySelector('[data-pp-accordion-items]');
  const source = accordionRoot.querySelector('[data-pp-accordion-source]');

  if (!itemsWrap || !source) return;

  const sourceHTML = (source.innerHTML || '').trim();
  if (!sourceHTML) return;

  const wrapper = document.createElement('div');
  wrapper.innerHTML = sourceHTML;

  const normalize = (s) => (s || '').replace(/\s+/g, ' ').trim().toLowerCase();

  const headingToSection = (text) => {
    const t = normalize(text).replace(/:$/, '');

    if (t.includes('feature')) return 'Features';
    if (t.includes('spec')) return 'Specifications';
    if (t === 'description' || t.includes('product description')) return 'Description';
    if (t.includes('shipping')) return 'Shipping';
    if (t.includes('warranty')) return 'Warranty';
    if (t.includes('return')) return 'Returns';

    return null;
  };

  const nodes = Array.from(wrapper.childNodes);
  const sections = [];
  let current = { title: 'Description', nodes: [] };

  const pushCurrent = () => {
    const html = current.nodes
      .map((node) => node.outerHTML ?? node.textContent ?? '')
      .join('')
      .trim();

    if (html) {
      sections.push({ title: current.title, html });
    }
  };

  nodes.forEach((node) => {
    if (node.nodeType === 1) {
      const tag = node.tagName.toUpperCase();

      if (/^H[1-6]$/.test(tag)) {
        const newTitle = headingToSection(node.textContent);
        if (newTitle) {
          pushCurrent();
          current = { title: newTitle, nodes: [] };
          return;
        }
      }

      if (tag === 'P') {
        const onlyStrong =
          node.children.length === 1 &&
          node.children[0].tagName?.toUpperCase() === 'STRONG' &&
          normalize(node.textContent) === normalize(node.children[0].textContent);

        if (onlyStrong) {
          const newTitle = headingToSection(node.textContent);
          if (newTitle) {
            pushCurrent();
            current = { title: newTitle, nodes: [] };
            return;
          }
        }
      }
    }

    current.nodes.push(node);
  });

  pushCurrent();

  if (sections.length <= 1) {
    itemsWrap.innerHTML = `
      <div class="pp-accordion__item is-open">
        <button
          type="button"
          class="pp-accordion__trigger"
          aria-expanded="true"
          aria-controls="pp-accordion-panel-0"
          id="pp-accordion-trigger-0"
        >
          <span class="pp-accordion__title">Description</span>
          <span class="pp-accordion__icon" aria-hidden="true">+</span>
        </button>
        <div
          class="pp-accordion__panel rte"
          id="pp-accordion-panel-0"
          role="region"
          aria-labelledby="pp-accordion-trigger-0"
        >
          <div class="pp-accordion__content">
            ${sourceHTML}
          </div>
        </div>
      </div>
    `;
    source.hidden = true;
    cleanupPanels();
    return;
  }

  const unique = [];
  const seen = new Set();

  for (const section of sections) {
    const key = normalize(section.title);

    if (seen.has(key)) {
      const found = unique.find((entry) => normalize(entry.title) === key);
      if (found) found.html += section.html;
    } else {
      seen.add(key);
      unique.push(section);
    }
  }

  const makeId = (title, i) =>
    `pp-accordion-${normalize(title).replace(/[^a-z0-9]+/g, '-')}-${i}`;

  itemsWrap.innerHTML = '';

  unique.forEach((section, i) => {
    const id = makeId(section.title, i);
    const triggerId = `${id}-trigger`;
    const panelId = `${id}-panel`;
    const isOpen = i === 0;

    const item = document.createElement('div');
    item.className = `pp-accordion__item${isOpen ? ' is-open' : ''}`;

    item.innerHTML = `
      <button
        type="button"
        class="pp-accordion__trigger"
        id="${triggerId}"
        aria-expanded="${isOpen ? 'true' : 'false'}"
        aria-controls="${panelId}"
      >
        <span class="pp-accordion__title">${section.title}</span>
        <span class="pp-accordion__icon" aria-hidden="true">+</span>
      </button>

      <div
        class="pp-accordion__panel rte"
        id="${panelId}"
        role="region"
        aria-labelledby="${triggerId}"
        ${isOpen ? '' : 'hidden'}
      >
        <div class="pp-accordion__content">
          ${section.html}
        </div>
      </div>
    `;

    itemsWrap.appendChild(item);
  });

  const items = Array.from(itemsWrap.querySelectorAll('.pp-accordion__item'));

  items.forEach((item) => {
    const trigger = item.querySelector('.pp-accordion__trigger');
    const panel = item.querySelector('.pp-accordion__panel');

    if (!trigger || !panel) return;

    trigger.addEventListener('click', () => {
      const isOpen = trigger.getAttribute('aria-expanded') === 'true';
      trigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      panel.hidden = isOpen;
      item.classList.toggle('is-open', !isOpen);
    });
  });

  source.hidden = true;
  cleanupPanels();
}


/* =========================
   Product page freight estimator
   ========================= */
function initProductShippingEstimator(container = document) {
  const root = container.querySelector('[data-product-shipping-estimator]');
  if (!root || root.dataset.productEstimatorBound === 'true') return;
  root.dataset.productEstimatorBound = 'true';

  const toggle = root.querySelector('[data-product-estimator-toggle]');
  const panel = root.querySelector('[data-product-estimator-panel]');
  const form = root.querySelector('[data-product-estimator-form]');
  const locationInput = root.querySelector('[data-product-estimator-location-query]');
  const suburbOptions = root.querySelector('[data-product-estimator-suburb-options]');
  const selectedSuburbElement = root.querySelector('[data-product-estimator-selected-suburb]');
  const button = root.querySelector('[data-product-estimator-button]');
  const status = root.querySelector('[data-product-estimator-status]');
  const results = root.querySelector('[data-product-estimator-results]');

  const ESTIMATE_ENDPOINT = window.FREIGHTMATE_PRODUCT_ESTIMATE_ENDPOINT
    || root.getAttribute('data-freightmate-product-estimate-endpoint')
    || '/apps/freightmate-v3/product-estimate';
  const AUSTRALIAN_POSTCODES_URL = root.getAttribute('data-australian-postcodes-url') || '';
  const SHOP_DOMAIN = root.getAttribute('data-shop-domain')
    || root.dataset.shop
    || (window.Shopify && window.Shopify.shop)
    || '';

  let selectedSuburb = null;
  let currentSuburbs = [];
  let activeOptionIndex = -1;
  let searchTimer = null;
  let searchController = null;
  const suburbCache = new Map();
  let localSuburbDataPromise = null;

  function endpointWithShop(endpoint) {
    let url;
    try {
      url = new URL(endpoint, window.location.origin);
    } catch (error) {
      return endpoint;
    }

    return url.toString();
  }

  async function readJsonResponse(response, fallbackMessage) {
    const text = await response.text();
    let data = null;

    try {
      data = text ? JSON.parse(text) : null;
    } catch (error) {
      data = null;
    }

    if (!response.ok) {
      const message = data && (data.description || data.message || data.error)
        ? data.description || data.message || data.error
        : fallbackMessage;
      const err = new Error(message);
      err.status = response.status;
      err.body = text;
      throw err;
    }

    if (!data || typeof data !== 'object') {
      const err = new Error('The FreightMate endpoint returned an invalid response.');
      err.status = response.status;
      err.body = text;
      throw err;
    }

    return data;
  }

  async function postProductEstimate(endpoint, payload, signal) {
    const response = await fetch(endpointWithShop(endpoint), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      credentials: 'same-origin',
      signal,
      body: JSON.stringify(payload)
    });

    return readJsonResponse(response, 'Unable to estimate freight right now.');
  }

  async function estimateProduct(payload) {
    return postProductEstimate(ESTIMATE_ENDPOINT, payload);
  }

  function createAbortError() {
    try {
      return new DOMException('The operation was aborted.', 'AbortError');
    } catch (error) {
      const abortError = new Error('The operation was aborted.');
      abortError.name = 'AbortError';
      return abortError;
    }
  }

  function loadLocalSuburbData() {
    if (Array.isArray(window.FREIGHTMATE_AU_SUBURBS)) {
      return Promise.resolve(window.FREIGHTMATE_AU_SUBURBS);
    }

    if (localSuburbDataPromise) return localSuburbDataPromise;

    if (!AUSTRALIAN_POSTCODES_URL) {
      return Promise.reject(new Error('The Australian postcode data asset is not configured.'));
    }

    localSuburbDataPromise = new Promise((resolve, reject) => {
      const existingScript = Array.from(
        document.querySelectorAll('script[data-australian-postcodes-src]')
      ).find((element) => element.dataset.australianPostcodesSrc === AUSTRALIAN_POSTCODES_URL);

      const finish = () => {
        if (Array.isArray(window.FREIGHTMATE_AU_SUBURBS)) {
          resolve(window.FREIGHTMATE_AU_SUBURBS);
        } else {
          reject(new Error('The Australian postcode data asset did not load correctly.'));
        }
      };

      if (existingScript) {
        if (Array.isArray(window.FREIGHTMATE_AU_SUBURBS)) {
          finish();
          return;
        }
        existingScript.addEventListener('load', finish, { once: true });
        existingScript.addEventListener('error', () => {
          reject(new Error('Unable to load the Australian postcode data.'));
        }, { once: true });
        return;
      }

      const script = document.createElement('script');
      script.src = AUSTRALIAN_POSTCODES_URL;
      script.async = true;
      script.dataset.australianPostcodesSrc = AUSTRALIAN_POSTCODES_URL;
      script.addEventListener('load', finish, { once: true });
      script.addEventListener('error', () => {
        reject(new Error('Unable to load the Australian postcode data.'));
      }, { once: true });
      document.head.appendChild(script);
    });

    return localSuburbDataPromise;
  }

  function normalizeSearchValue(value) {
    return String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^A-Z0-9]+/gi, ' ')
      .trim()
      .toUpperCase();
  }

  function displaySuburbName(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/(^|[\s'\-/])([a-z])/g, (match, prefix, letter) => `${prefix}${letter.toUpperCase()}`)
      .replace(/\bMc([a-z])/g, (match, letter) => `Mc${letter.toUpperCase()}`);
  }

  function localSuburbRank(record, normalizedQuery, numericQuery) {
    const postcode = String(record?.[0] || '');
    const suburb = normalizeSearchValue(record?.[1]);
    const state = normalizeSearchValue(record?.[2]);
    const searchable = `${suburb} ${state} ${postcode}`;

    if (numericQuery) return postcode === normalizedQuery ? 0 : 100;
    if (suburb === normalizedQuery) return 0;
    if (suburb.startsWith(normalizedQuery)) return 1;
    if (searchable.startsWith(normalizedQuery)) return 2;
    return 3;
  }

  async function fetchSuburbs(query, signal) {
    const cacheKey = normalizeSearchValue(query);
    if (suburbCache.has(cacheKey)) return suburbCache.get(cacheKey);

    const records = await loadLocalSuburbData();
    if (signal?.aborted) throw createAbortError();

    const normalizedQuery = normalizeSearchValue(query);
    const numericQuery = /^\d{4}$/.test(normalizedQuery);
    const queryTokens = normalizedQuery.split(/\s+/).filter(Boolean);

    const matches = records
      .filter((record) => {
        const postcode = String(record?.[0] || '');
        const searchable = normalizeSearchValue(
          `${record?.[1] || ''} ${record?.[2] || ''} ${postcode}`
        );

        if (numericQuery) return postcode === normalizedQuery;
        return queryTokens.every((token) => searchable.includes(token));
      })
      .sort((a, b) => {
        const rankDifference = localSuburbRank(a, normalizedQuery, numericQuery)
          - localSuburbRank(b, normalizedQuery, numericQuery);
        if (rankDifference) return rankDifference;

        const suburbDifference = String(a?.[1] || '').localeCompare(String(b?.[1] || ''), 'en-AU');
        if (suburbDifference) return suburbDifference;
        return String(a?.[2] || '').localeCompare(String(b?.[2] || ''), 'en-AU');
      })
      .slice(0, 30)
      .map((record) => {
        const postcode = String(record?.[0] || '');
        const rawName = String(record?.[1] || '').trim();
        const state = String(record?.[2] || '').trim().toUpperCase();
        const name = displaySuburbName(rawName);

        return {
          id: '',
          name,
          lookupName: `${rawName} ${state} ${postcode}`.trim(),
          postcode,
          state
        };
      });

    if (signal?.aborted) throw createAbortError();
    suburbCache.set(cacheKey, matches);
    return matches;
  }

  function suburbLabel(suburb) {
    return [suburb.name, suburb.state, suburb.postcode]
      .filter(Boolean)
      .join(' ');
  }

  function setOptionsOpen(open) {
    if (!suburbOptions || !locationInput) return;
    suburbOptions.hidden = !open;
    locationInput.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function updateActiveOption(nextIndex) {
    if (!suburbOptions || !currentSuburbs.length) return;

    activeOptionIndex = Math.max(0, Math.min(nextIndex, currentSuburbs.length - 1));

    suburbOptions.querySelectorAll('[data-suburb-option]').forEach((option, index) => {
      const active = index === activeOptionIndex;
      option.classList.toggle('is-active', active);
      option.setAttribute('aria-selected', active ? 'true' : 'false');
      if (active) option.scrollIntoView({ block: 'nearest' });
    });
  }

  function clearSelectedSuburb({ keepInput = true } = {}) {
    selectedSuburb = null;
    root.removeAttribute('data-selected-suburb-id');
    root.removeAttribute('data-selected-suburb-name');
    root.removeAttribute('data-selected-suburb-postcode');

    if (!keepInput && locationInput) locationInput.value = '';
    if (selectedSuburbElement) {
      selectedSuburbElement.hidden = true;
      selectedSuburbElement.textContent = '';
    }
    locationInput?.removeAttribute('aria-invalid');
  }

  function selectSuburb(suburb) {
    if (!suburb || !locationInput) return;

    selectedSuburb = suburb;
    locationInput.value = suburbLabel(suburb);
    locationInput.removeAttribute('aria-invalid');

    root.dataset.selectedSuburbId = suburb.id || '';
    root.dataset.selectedSuburbName = suburb.name;
    root.dataset.selectedSuburbPostcode = suburb.postcode;

    if (selectedSuburbElement) {
      selectedSuburbElement.hidden = false;
      selectedSuburbElement.textContent = `Selected delivery suburb: ${suburbLabel(suburb)}`;
    }

    currentSuburbs = [];
    activeOptionIndex = -1;
    setOptionsOpen(false);
    showProductEstimatorStatus(status, '', false, true);
  }

  function renderSuburbOptions(suburbs, message = '') {
    if (!suburbOptions) return;

    currentSuburbs = suburbs;
    activeOptionIndex = -1;
    suburbOptions.innerHTML = '';

    if (!suburbs.length) {
      const empty = document.createElement('div');
      empty.className = 'pp-product-estimator__suburb-empty';
      empty.textContent = message || 'No matching suburbs found.';
      suburbOptions.appendChild(empty);
      setOptionsOpen(true);
      return;
    }

    suburbs.forEach((suburb, index) => {
      const option = document.createElement('button');
      option.type = 'button';
      option.className = 'pp-product-estimator__suburb-option';
      option.dataset.suburbOption = String(index);
      option.setAttribute('role', 'option');
      option.setAttribute('aria-selected', 'false');
      option.innerHTML = `
        <span>${escapeHTML(suburb.name)}</span>
        <small>${escapeHTML([suburb.state, suburb.postcode].filter(Boolean).join(' '))}</small>
      `;
      option.addEventListener('mousedown', (event) => event.preventDefault());
      option.addEventListener('click', () => selectSuburb(suburb));
      suburbOptions.appendChild(option);
    });

    setOptionsOpen(true);
  }

  async function runSuburbSearch(rawQuery) {
    const query = String(rawQuery || '').trim();
    const numericQuery = /^\d+$/.test(query);
    const canSearch = numericQuery ? /^\d{4}$/.test(query) : query.length >= 2;

    if (!canSearch) {
      currentSuburbs = [];
      setOptionsOpen(false);
      return [];
    }

    searchController?.abort();
    searchController = new AbortController();
    renderSuburbOptions([], 'Searching suburbs...');

    try {
      const suburbs = await fetchSuburbs(query, searchController.signal);
      renderSuburbOptions(suburbs);
      return suburbs;
    } catch (error) {
      if (error.name === 'AbortError') return [];
      console.error(error);
      renderSuburbOptions([], error.message || 'Unable to search suburbs right now.');
      return [];
    }
  }

  const setOpen = (open) => {
    root.classList.toggle('is-open', open);
    if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (panel) panel.hidden = !open;
    if (open) window.setTimeout(() => locationInput?.focus(), 80);
    if (!open) setOptionsOpen(false);
  };

  toggle?.addEventListener('click', () => {
    setOpen(!root.classList.contains('is-open'));
  });

  locationInput?.addEventListener('input', () => {
    const value = locationInput.value;

    if (selectedSuburb && value !== suburbLabel(selectedSuburb)) {
      clearSelectedSuburb({ keepInput: true });
    }

    if (results) {
      results.hidden = true;
      results.innerHTML = '';
    }

    window.clearTimeout(searchTimer);
    searchTimer = window.setTimeout(() => runSuburbSearch(value), 300);
  });

  locationInput?.addEventListener('focus', () => {
    if (currentSuburbs.length) setOptionsOpen(true);
  });

  locationInput?.addEventListener('keydown', (event) => {
    if (!suburbOptions || suburbOptions.hidden) return;

    if (event.key === 'ArrowDown') {
      event.preventDefault();
      updateActiveOption(activeOptionIndex + 1);
    } else if (event.key === 'ArrowUp') {
      event.preventDefault();
      updateActiveOption(activeOptionIndex <= 0 ? currentSuburbs.length - 1 : activeOptionIndex - 1);
    } else if (event.key === 'Enter' && activeOptionIndex >= 0) {
      event.preventDefault();
      selectSuburb(currentSuburbs[activeOptionIndex]);
    } else if (event.key === 'Escape') {
      setOptionsOpen(false);
    }
  });

  document.addEventListener('click', (event) => {
    if (!root.contains(event.target)) setOptionsOpen(false);
  });

  form?.addEventListener('submit', async (event) => {
    event.preventDefault();

    if (!selectedSuburb) {
      const query = String(locationInput?.value || '').trim();
      locationInput?.setAttribute('aria-invalid', 'true');

      const suburbs = await runSuburbSearch(query);
      const message = suburbs.length
        ? 'Please select the correct suburb from the list before estimating freight.'
        : 'Enter a suburb name or 4-digit postcode, then select a matching suburb.';
      showProductEstimatorStatus(status, message, true);
      return;
    }

    const postcode = selectedSuburb.postcode;
    if (!/^\d{4}$/.test(postcode)) {
      showProductEstimatorStatus(status, 'The selected suburb does not have a valid Australian postcode.', true);
      return;
    }

    const quantityInput = container.querySelector('[data-pp-qty-input]');
    const quantity = Math.max(1, parseInt(quantityInput?.value, 10) || 1);
    const originalText = button?.textContent || 'Estimate';

    if (button) {
      button.disabled = true;
      button.classList.add('is-loading');
      button.textContent = 'Estimating...';
    }
    if (results) {
      results.hidden = true;
      results.innerHTML = '';
    }
    showProductEstimatorStatus(status, `Checking freight to ${suburbLabel(selectedSuburb)}...`, false);

    const payload = {
      shop: SHOP_DOMAIN,
      postcode,
      suburb: selectedSuburb.name,
      suburb_name: selectedSuburb.name,
      suburb_lookup_name: selectedSuburb.lookupName,
      suburb_id: selectedSuburb.id || undefined,
      state: selectedSuburb.state || undefined,
      product_id: root.dataset.productId || '',
      variant_id: root.dataset.variantId || '',
      sku: root.dataset.sku || '',
      title: root.dataset.title || document.querySelector('.product-page__title')?.textContent?.trim() || 'Product',
      quantity,
      grams: numberFromData(root.dataset.grams),
      price: numberFromData(root.dataset.price),
      currency: root.dataset.currency || 'AUD',
      product_url: root.dataset.productUrl || window.location.href,
      product_image: root.dataset.productImage || '',
      delivery_suburb: {
        id: selectedSuburb.id || undefined,
        name: selectedSuburb.name,
        lookup_name: selectedSuburb.lookupName,
        postcode,
        state: selectedSuburb.state || undefined
      },
      destination: {
        country: 'AU',
        postal_code: postcode,
        city: selectedSuburb.name,
        suburb: selectedSuburb.name,
        suburb_id: selectedSuburb.id || undefined,
        province_code: selectedSuburb.state || undefined
      },
      attribution: {
        source: 'product_page_estimator',
        path: window.location.pathname,
        title: document.title
      }
    };

    try {
      const data = await estimateProduct(payload);

      if (Array.isArray(data.rates) && data.rates.length) {
        renderProductEstimatorRates(results, data.rates, data.product_estimator_mode);
        showProductEstimatorStatus(status, `Estimated freight to ${suburbLabel(selectedSuburb)}:`, false);
      } else {
        showProductEstimatorStatus(status, data.error || 'No estimate was returned. Please continue to checkout for final freight options.', true);
      }
    } catch (error) {
      console.error(error);
      showProductEstimatorStatus(status, error.message || 'Unable to estimate freight right now.', true);
    } finally {
      if (button) {
        button.disabled = false;
        button.classList.remove('is-loading');
        button.textContent = originalText;
      }
    }
  });
}

function showProductEstimatorStatus(element, message, isError, hideWhenEmpty = false) {
  if (!element) return;
  element.textContent = message || '';
  element.hidden = hideWhenEmpty && !message;
  element.classList.toggle('is-error', !!isError);
}

function renderProductEstimatorRates(element, rates, mode) {
  if (!element) return;
  element.hidden = false;
  element.innerHTML = rates.map((rate) => {
    const cents = Number(rate.total_price);
    const price = Number.isFinite(cents)
      ? new Intl.NumberFormat('en-AU', { style: 'currency', currency: rate.currency || 'AUD' }).format(cents / 100)
      : 'TBC';
    const description = rate.description ? `<div class="pp-product-estimator__rate-desc">${escapeHTML(rate.description)}</div>` : '';
    return `<div class="pp-product-estimator__rate"><div><strong>${escapeHTML(rate.service_name || rate.name || 'Freight estimate')}</strong>${description}</div><span>${escapeHTML(price)}</span></div>`;
  }).join('');
}

function productEstimatorModeLabel(mode) {
  if (mode === 'business') return 'Business Delivery - Forklift Onsite';
  if (mode === 'businessTailgate') return 'Business Delivery - Tailgate';
  if (mode === 'residential') return 'Residential Delivery';
  if (mode === 'allEnabled') return 'all enabled delivery methods';
  return 'Depot Collection';
}

function numberFromData(value) {
  const n = Number(value);
  return Number.isFinite(n) ? n : undefined;
}

function escapeHTML(value) {
  return String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

/* =========================
   Cart feedback animation
   ========================= */
function animateCartFeedback(button, quantity = 1) {
  button.classList.add('pp-atc--pulse');
  window.setTimeout(() => {
    button.classList.remove('pp-atc--pulse');
  }, 550);

  const cartTarget =
    document.querySelector('[data-open-cart]') ||
    document.querySelector('.hdr__cartBtn');

  if (!cartTarget) return;

  cartTarget.classList.add('cart-bump');
  window.setTimeout(() => {
    cartTarget.classList.remove('cart-bump');
  }, 700);

  let badge = cartTarget.querySelector('.pp-cart-added-badge');

  if (!badge) {
    badge = document.createElement('span');
    badge.className = 'pp-cart-added-badge';
    cartTarget.appendChild(badge);
  }

  badge.textContent = `+${quantity}`;
  badge.classList.remove('is-animating');
  void badge.offsetWidth;
  badge.classList.add('is-animating');
}

document.addEventListener('DOMContentLoaded', () => {
  initProductPage(document);
  initProductShippingEstimator(document);
});

document.addEventListener('shopify:section:load', (event) => {
  initProductPage(event.target);
  initProductShippingEstimator(event.target);
});
